import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ExternalGenericDocContainerModel } from "../../../../../../models";
import { BaseApiTemplateService, Core2Config,ApiVisa,PagingResponseModel } from "../../shared";

//https://api.akaun.cloud/core2/tnt/dm/erp/xtn/gen-doc/backoffice-ep

@Injectable({ providedIn: "root" })
export class ExternalGenericDocService extends BaseApiTemplateService<ExternalGenericDocContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX +  Core2Config.ERP_PREFIX + "xtn/gen-doc/backoffice-ep";
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX +  Core2Config.ERP_PREFIX + "xtn/gen-doc/backoffice-ep";
    this.httpClient = http;
  }

  getSupplierExternalGenericDocHdr(visa: ApiVisa){
    const apiUrl = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX  + 'xtn/gen-doc/supplier-ep';
    return this.httpClient.get<PagingResponseModel<ExternalGenericDocContainerModel>>(apiUrl, this.getHttpHeader(visa));
  }
}
